<!-- 收缩面板 -->
<template>
  <div class="zlr-card-shink">
    <h1>
      <span>{{title}}</span>
      <a @click.stop="isShow = !isShow">{{isShow? '点击收起': '点击展示' }}</a>
    </h1>
    <div class="zlr-card-shink-container"
         v-show="isShow">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// less
import './card-shrink.less'
export default {
  name: 'zlr-card-shink',
  props: {
    title: {
      type: [String],
      required: true
    },
    show: {
      type: [Boolean],
      default: true
    }
  },
  components: {},
  data () {
    return {
      isShow: this.show
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
